<div class="container-fluid wrapper-page">
  <div class="page-head">
    <div class="row">
      <div class="col-12">
        <h5 class="header-title heading-color">APPOINTMENTS TO CHECK-OUT</h5>
      </div>
      <div class="col-lg-12">
        <div class="card m-b-30">
          <form #checkoutForm="ngForm">
            <div class="card-body">
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                  <div class="row">

                    <div class="col-md-4 margin-bottom">
                      <ng-template #rt let-r="result" let-t="term">
                        {{ r.pat_name }}
                      </ng-template>
                      <input type="search" placeholder="Patient name" aria-label="Search" name="model"
                        [(ngModel)]="model" class="form-control" />
                    </div>

                    <div class="col-md-4 margin-bottom">
                      <ng-template #rt let-r="result" let-t="term">
                        {{ r.doc_name }}
                      </ng-template>
                      <input type="search" placeholder="Physician name" aria-label="Search" name="model2"
                        [(ngModel)]="model2" class="form-control" />
                    </div>




                    <div class="input-group margin-bottom col-md-4 m-t-10">
                      <input name="chkdob" class="form-control" placeholder="AP Date (DD/MM/YYYY)" [(ngModel)]="chkdob"
                        ngbDatepicker #d="ngbDatepicker" data-date-inline-picker="false" />
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()" type="button"
                          style="line-height: 2.5;">
                          <span class="fa fa-calendar"></span>
                        </button>
                      </div>
                      <div *ngIf="isError" class="invalid-feedback">
                        Invalid date
                      </div>
                    </div>


                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-5 center-mobile">
                      <button type="submit" (click)="displayAppoint(checkoutForm.value)"
                        class="btn btn-mobile btn-primary">
                        FIND APPOINTMENTS
                      </button>
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                </div>
                <div class="col-md-4"></div>
              </div>
            </div>
          </form>
          <div *ngIf="isCheckOutLoading">
            <appLoader [size]="small" [display]="isCheckOutLoading" [screen]="container" style="z-index: 1000;">
            </appLoader>
          </div>
        </div>
      </div>
    </div>
    <!--END ROW-->

    <div id="appdesktop" *ngIf="checkout">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card m-b-30">
            <div class="card-body table-responsive">
              <div class="row">
                <div align="center" class="col-lg-12">
                  <h4 class="header-title heading-color">ACTIVE CHECK-IN</h4>
                </div>
              </div>
              <br />

              <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <table id=" datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <thead align="center">
                        <tr role="row">
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 15%;">
                            AP DATE & TIME
                          </th>

                          <!-- <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 15%;">
                            AP TIME
                          </th> -->

                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending" style="width: 15%;">
                            PATIENT
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Age: activate to sort column ascending" style="width: 15%;">
                            Physician
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 15%;">
                            SUMMARY
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 15%;">
                            PRESCRIPTION
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 15%;">
                            LAB REQUEST
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 15%;">
                            INVOICE
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Start date: activate to sort column ascending" style="width: 15%;">
                            ACTION
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" *ngFor="let data of checkout; let i = index">
                          <td>{{ data["apdate"] | date: dateFormat }} <br> {{ formatTime(data["aptime"]) }}</td>
                          <!-- <td>{{ formatTime(data["aptime"]) }}</td> -->
                          <td>
                            {{ data["patient_first_name"] }}
                            {{ data["patient_last_name"] }}
                          </td>
                          <!-- <td>{{ data["dob"] | date: dateFormat }}</td> -->
                          <td>
                            {{ data["physician_first_name"] }}
                            {{ data["physician_last_name"] }}
                          </td>
                          <td class="text-capitalize">
                            <a href="javascript:void(0);" (click)="printConsult(data.aid)">Download</a>

                          </td>
                          <td class="text-capitalize">

                            <a (click)="showprescr(data.aid,data.pid,data.u_id)" id="showPrescription">Download</a>
                          </td>
                          <td class="text-capitalize">
                            <a (click)="showlabrep($event,data.aid,data.pid)" id="showlabRep">Download</a>
                          </td>
                          <td class="text-capitalize">
                            <!-- <button type="button" (click)="editRequest(data.aid,data.pid)"
                              class="tabledit-edit-button btn btn-sm btn-info mr-2 edit">
                              Generate
                            </button> -->
                            <a (click)="showservicerep($event,data.aid,data.pid,data.u_id)"
                              id="showserviceRep">Generate/Download</a>
                          </td>

                          <td>

                            <div class="btn-group btn-group-sm" style="float: none;">
                              <button type="button" (click)="patientCheckout(data.aid, data.pid)"
                                class="tabledit-delete-button btn btn-sm btn-success">
                                <span class="fa fa-sign-out"></span> CHECK-OUT
                              </button>
                            </div>

                          </td>
                        </tr>
                      </tbody>

                    </table>
                    <div [innerHTML]="innerHtml"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--/#appdesktop  -->

    <div id="appmobile">
      <div class="col-sm-12">
        <h5 class="header-title  heading-color center-mobile">ACTIVE CHECK-IN</h5>
      </div>
      <div [innerHTML]="innerHtml"></div>
      <div class="row" *ngFor="let data of checkout; let i = index">

        <div class="col-12 col-sm-12">

          <div class="mcard">
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">AP DATE</span>
              </div>
              <div class="cardcol">
                <span class="textblack">{{ data["apdate"] | date: "dd-MMM-yyyy" }}
                </span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">AP TIME</span>
              </div>
              <div class="cardcol">
                <span class="textblack">{{ formatTime(data["aptime"]) }}

                </span>
              </div>
            </div>
            <!-- /cardrow -->


            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">PATIENT</span>
              </div>
              <div class="cardcol">
                <span class="textblack">{{ data["patient_first_name"] }}
                  &nbsp;{{ data["patient_last_name"] }}
                </span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">DOB</span>
              </div>
              <div class="cardcol">
                <span class="textblack">{{
                  data["dob"] | date: "dd-MMM-yyyy"
                  }}</span>
              </div>
            </div>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">CONSULTED DOCTOR</span>
              </div>
              <div class="cardcol">
                <span class="textblack">Dr.{{ data["physician_first_name"] }}
                  &nbsp; {{ data["physician_last_name"] }}
                </span>
              </div>
            </div> <br>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">PRESCRIPTION</span>
              </div>
              <div class="cardcol">
                <span class="textblack"> <a (click)="showprescr($event,data.aid,data.pid)"
                    id="showPrescription">Download</a>
                </span>
              </div>
            </div> <br>
            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">LAB REQUEST</span>
              </div>
              <div class="cardcol">
                <span class="textblack">Print
                </span>
              </div>
            </div> <br>

            <!-- /cardrow -->
            <div class="cardrow">
              <div class="cardcol">
                <span class="textgrey">INVOICE</span>
              </div>
              <div class="cardcol">
                <span class="textblack">Pt / Gt
                </span>
              </div>
            </div> <br>

            <!-- /cardrow -->
            <div class="cardrow">

              <div class="cardcol">

              </div>
            </div> <br>

            <div align="center">

              <div class="btn-group btn-group-sm ">
                <button type="button" (click)="patientCheckout(data['aid'])"
                  class="tabledit-delete-button btn btn-sm btn-success">
                  <span class="fa fa-sign-out"></span> CHECK-OUT
                </button>
              </div>

            </div>



          </div>
          <!-- /mcard -->
        </div>
        <!-- /col -->
      </div>
      <!-- /row -->
      <!-- <div class="row" *ngIf="checkoutStatus">
        <div class="col-md-12 text-center">
          <h6 class="heading-bottom">
            CHECKOUT OF<span class="title-blue"> {{ checkout[0].pat_name }}</span>
            HAS BEEN SUCCESSFULLY DONE!
          </h6>


        </div>

      </div> -->
      <!-- /row -->
    </div>
    <!-- /#appmobile -->
  </div>
</div>
<!--end container-->


<ng-template #showprescriptionModal let-modal>
  <div class="container-fluid ">
    <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
        style="font-size:18px;color:red;"></a></div>
    <div class="">
      <div class="row">
        <div class="col-sm-12">
          <h6 class="heading_color bottomTitle">
            Patient's Current Prescription
            <div style="text-align:right;"> <br /> <a href="javascript:void(0);" (click)="printPage($event)"
                class="fa fa-file-pdf-o" style="font-size:18px;color:blue" id="CurrentPrescription"></a></div>
            <!-- <span style="text-align:right;">
              <a href="javascript:void(0);" (click)="printPage($event)" class="fa fa-file-pdf-o"
                style="font-size:18px;color:blue" id="CurrentPrescription"></a>
              <i class="fa fa-cloud-download"></i>
            </span> -->
          </h6>
          <div class="card-body-1 table-responsive">
            <br>
            <div class="">
              <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <thead>
                        <tr role="row">
                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-sort="ascending" aria-label="Name: activate to sort column descending"
                            style="width: 12.3%;">
                            Medicine</th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 12.3%;">
                            Strength</th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 12.3%">
                            Freq</th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 12.3%">
                            Intake</th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 12.3%">Valid from
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            style="width: 12.3%">Valid till
                          </th>

                        </tr>
                      </thead>

                      <tr align="center" *ngIf="currentPrescriptionList?.length === 0">
                        <td></td>
                        <td colspan="4">
                          <div class=" card m-b-30">
                            <div>
                              <div class="row">
                                <h5 class="text-danger text-center" *ngIf="currentPrescriptionList?.length === 0">
                                  No prescription prescribed for this appointment</h5>
                              </div>
                            </div>
                          </div>
                        </td>

                      </tr>

                      <tbody>

                        <tr role="row" class="odd" *ngFor="let record of currentPrescriptionList">
                          <td>{{record.mname}}</td>
                          <td>{{record.strength}}</td>
                          <td>{{record.intakefreq}}</td>
                          <td>{{record.intake}}</td>
                          <td>{{record.sdate| date:'dd-MM-yyyy'}}</td>
                          <td>{{record.edate| date:'dd-MM-yyyy'}}</td>
                        </tr>

                      </tbody>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #showlabrepModal let-modal>
  <div class="container-fluid ">
    <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
        style="font-size:18px;color:red;"></a></div>
    <div class="">
      <div class="row">
        <div class="col-sm-12">
          <h6 class="heading_color bottomTitle">
            Lab Requests
            <div style="text-align:right;"> <br /> <a href="javascript:void(0);" (click)="printPagee($event)"
                class="fa fa-file-pdf-o" style="font-size:18px;color:blue" id="lap_records"></a></div>
            <!-- <span>
              <a href="javascript:void(0);" (click)="printPagee($event)" class="fa fa-file-pdf-o"
                style="font-size:18px;color:blue" id="lap_records"></a>&nbsp;&nbsp;&nbsp;            </span> -->
          </h6>
          <div class="card-body-1 table-responsive">
            <br>
            <div class="">
              <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <thead>
                        <tr role="row">
                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-sort="ascending" aria-label="Name: activate to sort column descending"
                            style="width: 16%;">Date
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Position: activate to sort column ascending" style="width: 16%;">Name
                            of test</th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending" style="width: 16%">Remarks
                          </th>

                        </tr>
                      </thead>

                      <tbody>
                      <tbody>
                        <tr role="row" class="odd" *ngFor="let record of testsList">
                          <td>{{record.tdate| date:'dd-MM-yyyy'}}</td>
                          <td>{{record.labtest_name}}
                            <input type="hidden" name="testid" value="record.testid">
                          </td>
                          <td>{{record.remarks}}</td>

                        </tr>
                        <tr align="center" *ngIf="testsList?.length === 0">

                          <td></td>
                          <td>
                            <div class=" card m-b-30">
                              <div>
                                <div class="row">
                                  <h5 class="text-danger text-center" *ngIf="testsList?.length === 0">
                                    No lab requests for this appointment</h5>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>





<ng-template #showservicerepModal let-modal>

  <div class="container-fluid ">
    <div style="text-align:right;"> <br /><a data-dismiss="modal" href="javascript:void(0);" class="fa fa-close"
        (click)="exit();modal.dismiss()" style="font-size:18px;color:red;"></a></div>
    <h4>&nbsp;&nbsp;Bill Generation&nbsp;&nbsp;</h4>
    <form [formGroup]="forms['medicalHistory']">
      <div class="row cust_row" align="center">
        <div class="col-sm-12">

          <div class="form-group" formArrayName="patient_med_history"
            *ngFor="let item of forms['medicalHistory'].get('patient_med_history')['controls']; let i = index;">
            <div class="row" [formGroupName]="i">
              &nbsp;&nbsp;
              <div class="col-sm-1"></div>
              <div class="col-6 col-sm-6 col-md-3 m-m ">
                <select formControlName="sid" #sid name="sid" class="form-control"
                  (change)="onChange($event.target.value,i)">
                  <option *ngFor="let x of diseaseList" [value]="x.service_id" [value]="x.service_id"
                    (change)="onSelected(x.service_cost)">{{x.service_name}}</option>
                </select>
              </div>


              <div class="col-6 col-sm-10 col-md-5 m-m">
                <input formControlName="scost" type="number" class="form-control" [value]="service_cost[i]"
                  autofocus="autofocus" [value]="service_cost[i]" placeholder="Enter the Cost of this Service"
                  (focusout)="onSearchChange($event.target.value)">
              </div>


              <div class="col-4 col-sm-2 col-md-1 m-m text-right" *ngIf=" i >0">
                <button type="button" class="btn btn-outline-primary removeitem" (click)="removingMedicalHistory(i)"
                  style="padding: 12px 16px;"><i class="fa fa-close"></i></button>
              </div>

              <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                *ngIf="i == (forms['medicalHistory'].get('patient_med_history')['controls'].length - 1)">
                <button type="button" class="btn btn-outline-primary addmore" style="padding: 12px 16px;"
                  (click)="addingMoreMedicalHistory();"><i class="fa fa-plus"></i></button>
              </div>

            </div>


          </div>
        </div>
      </div>

      <div class="row ">
        <div class="col-md-12" align="center">
          <button type="button" [disabled]="!forms['medicalHistory'].get('patient_med_history').value[forms['medicalHistory'].get('patient_med_history')['controls'].length
          - 1].sid " class="btn btn-primary pl-5 pr-5 mr-2 btn-rounded" (click)="savePatient()">Save</button>
        </div>
      </div>
    </form>

    <!-- <div class="row ">
      <div class="col-md-12" align="center">
        <button type="button" [disabled]="!forms['medicalHistory'].get('patient_med_history').value[0].scost "
          class="btn btn-primary pl-5 pr-5 mr-2 btn-rounded" (click)="savePatient()">Save</button>
      </div>
    </div> -->
    <br /><br /><br />
  </div>








  <div class="container-fluid ">
    <!-- <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
        style="font-size:18px;color:red;"></a></div> -->
    <div class="">
      <div class="row">
        <div class="col-sm-12">
          <h6 class="heading_color bottomTitle">
            INVOICE
            <div style="text-align:right;"> <br /><a href="javascript:void(0);" (click)="printInvoice($event)"
                class="fa fa-file-pdf-o" style="font-size:18px;color:blue" id="lap_records"></a></div>
            <!-- <span>
              <a href="javascript:void(0);" (click)="printInvoice($event)" class="fa fa-file-pdf-o"
                style="font-size:18px;color:blue" id="lap_records"></a>&nbsp;&nbsp;&nbsp;

            </span> -->
          </h6>
          <div class="card-body-1 table-responsive">
            <br>
            <div class="">
              <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <thead>
                        <tr role="row">
                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-sort="ascending" aria-label="Name: activate to sort column descending"
                            style="width: 10%;">S.No
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Position: activate to sort column ascending" style="width: 30%;">Service Name
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending"
                            style="width: 30%;text-align: right;">Service Cost
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending"
                            style="width: 30%;text-align: center">Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr role="row" class="odd" *ngFor="let record of serviceList; let i = index">

                          <td>{{i+1}}</td>
                          <td>{{record.service_name}}
                            <input type="hidden" name="testid" value="record.testid">
                          </td>
                          <!-- <td>{{record.scost}}</td> -->
                          <td style="text-align: right;">{{ record.scost | number:'2.2-2'}}</td>
                          <td>
                            <div style="text-align:center;"> <br /><a href="javascript:void(0);" class="fa fa-close"
                                (click)="delete(record)" style="font-size:18px;color:red;"></a></div>
                          </td>
                        </tr>
                        <tr *ngIf="!serviceList || serviceList?.length">
                          <td colspan="2" style="text-align: center;">TOTAL</td>
                          <td style="text-align: right;">{{totalamount | number:'2.2-2'}}</td>
                          <td></td>
                        </tr>
                      </tbody>
                      <tr align="center" *ngIf="serviceList?.length === 0">

                        <td></td>
                        <td></td>
                        <td>
                          <div class=" card m-b-30">
                            <div>
                              <div class="row">
                                <h5 class="text-danger text-center" *ngIf="serviceList?.length === 0">
                                  Bill yet to generate</h5>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </table>
                    <!-- <table id="datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <thead>
                        <tr role="row">
                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-sort="ascending" aria-label="S.no: activate to sort column descending"
                            style="width: 16%;">S.No
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Name: activate to sort column ascending" style="width: 16%;">Service Name
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Service cost: activate to sort column ascending" style="width: 16%">Service Cost
                          </th>
                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Action: activate to sort column ascending" style="width: 16%">Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr role="row" class="odd" *ngFor="let record of serviceList; let i = index">
                          <td class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending" style="width: 16%">{{i+1}}</td>
                          <td class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending" style="width: 16%">
                            {{record.service_name}}
                            <input type="hidden" name="testid" value="record.testid">
                          </td>
                          <td class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                            aria-label="Office: activate to sort column ascending" style="width: 16%">{{record.scost |
                            number:'2.2-2'}}
                          </td>
                          <td>
                            <div align="left-top"> <a href="javascript:void(0);" class="fa fa-close"
                                (click)="delete(record)" style="font-size:18px;color:red;"></a></div>
                          </td>
                        </tr>
                        <tr *ngIf="!serviceList || serviceList?.length">
                          <td colspan="2" style="text-align: center;">TOTAL</td>
                          <td>{{totalamount | number:'2.2-2'}}</td>
                        </tr>
                      </tbody>
                    </table> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>